import React, { useEffect, useRef } from 'react';
import ReactPlayer from 'react-player';
import styled from 'styled-components';

const VideoPlay = ({ url = undefined, className, onEnded = () => {} }) => {
  const autoEndTimeoutIdRef = useRef(null);
  const hasFiredEndedRef = useRef(false);

  const handleProgress = ({ played }) => {
    if (hasFiredEndedRef.current) {
      return;
    }

    if (played >= 0.9 && !autoEndTimeoutIdRef.current) {
      autoEndTimeoutIdRef.current = setTimeout(() => {
        hasFiredEndedRef.current = true;
        autoEndTimeoutIdRef.current = null;
        onEnded();
      }, 1000);
    }
  };

  useEffect(() => {
    hasFiredEndedRef.current = false;

    if (autoEndTimeoutIdRef.current) {
      clearTimeout(autoEndTimeoutIdRef.current);
      autoEndTimeoutIdRef.current = null;
    }

    return () => {
      if (autoEndTimeoutIdRef.current) {
        clearTimeout(autoEndTimeoutIdRef.current);
        autoEndTimeoutIdRef.current = null;
      }
    };
  }, [url]);

  return (
    <Container className={className}>
      <Content>
        {url && (
          <ReactPlayer
            url={url}
            controls={true}
            onProgress={handleProgress}
            loop={false}
            width="100%"
            height="100%"
            config={{
              youtube: {
                playerVars: {
                  rel: 0,
                  loop: 0,
                },
              },
            }}
          />
        )}
      </Content>
    </Container>
  );
};

const Container = styled.div`
  position: relative;
  width: 100%;
  padding-bottom: 100%;
  background-color: rgba(0, 0, 0, 0.1);
  border-radius: 20px;
  overflow: hidden;
`;

const Content = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
`;

export default VideoPlay;